module.exports = __webpack_public_path__ + "img/bg-event-space-capital-one.fa504bdf.jpg";